import { useState, useEffect } from 'react';
import { ResponsiveState } from '../types/types';

const useResponsive = (): ResponsiveState => {
  const [responsiveState, setResponsiveState] = useState<ResponsiveState>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isLargeDesktop: false,
    screenWidth: 0,
    screenHeight: 0,
  });

  useEffect(() => {
    const updateResponsiveState = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setResponsiveState({
        isMobile: width <= 576,
        isTablet: width > 576 && width <= 768,
        isDesktop: width > 768 && width <= 1024,
        isLargeDesktop: width > 1024,
        screenWidth: width,
        screenHeight: height,
      });
    };

    // Initial call
    updateResponsiveState();

    // Add event listener
    window.addEventListener('resize', updateResponsiveState);

    // Cleanup
    return () => window.removeEventListener('resize', updateResponsiveState);
  }, []);

  return responsiveState;
};

export default useResponsive;
